import { useState } from "react";
import { useLocation } from "react-router";
import type { NavigationState } from "@acto/taskpane/core/chat";

interface ChatSession {
  /** Remount key for the assistant runtime. A new value starts a new conversation. */
  key: string;
  initialMessage?: string;
}

export function useChatSession(customerId: string | undefined) {
  const location = useLocation();
  const initialMessage = (location.state as NavigationState | null)?.initialMessage;

  const [session, setSession] = useState(() => ({ nonce: 0, message: initialMessage }));

  const startNewChat = (message?: string) =>
    setSession((s) => ({ nonce: s.nonce + 1, message: message?.trim() || undefined }));

  const current: ChatSession = {
    key: `${customerId ?? "general"}:${session.nonce}`,
    initialMessage: session.message,
  };

  return { session: current, startNewChat };
}
